import Dialog from '@/components/dialog';
//import { clearAll } from '@/scripts/utils';
import { useSessionContext } from '@/contexts/session/context';
import { msgExpireDurationOptions } from '@/configs/options';
import { Card } from '../card';
import MoreIcon from '../../images/more.svg?react';
import styles from './index.module.scss';
import DelTitleIc from './images/delTitle.svg?react';
import DelWarnIc from './images/delWarn.svg?react';

const Security = () => {
  const {
    logout,
    userSettings: { userSettingsState, setUserSettings },
  } = useSessionContext();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(1);

  const handleChange = (value: number) => {
    setUserSettings({ expire_duration: value });
  };

  const data = [
    {
      title: 'Security',
      description:
        'All messages in chats you start will be automatically deleted for everyone at some point after they have been sent.',
      data: [
        {
          key: '1',
          title: 'Auto-Delete Messages',
          extra: (
            <Select
              value={userSettingsState.expire_duration}
              style={{ width: 170 }}
              onChange={handleChange}
              options={msgExpireDurationOptions}
            />
          ),
        },
      ],
    },
    {
      data: [
        {
          key: '3',
          title: <div className={styles.deleteAccountItem}>Delete My Account</div>,
          extra: <MoreIcon />,
          onClick: () => setOpen(true),
        },
      ],
    },
  ];

  const deleteAccount = () => {
    Dialog({
      title: 'Proceed to Delete Your Account?',
      centered: true,
      content: (
        <div>
          <div>Deleting your account will permanently delete your data!</div>
          <div>It is impossible to reverse this action!</div>
        </div>
      ),
      confirmText: 'Delete My Account',
      onConfirm: () => {
        // clearAll();
        logout();
      },
      onCancel: () => {
        setOpen(false);
      },
    });
  };

  useEffect(() => {
    if (open) {
      setCurrent(1);
    }
  }, [open]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>Security</div>
      <div className={styles.content}>
        {data.map((item, index) => {
          return (
            <Card
              className={styles.card}
              key={index}
              title={item.title}
              description={item.description}
              data={item.data}
            ></Card>
          );
        })}
      </div>
      <Modal
        title="Delete My Account"
        maskClosable={false}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
      >
        <div className={styles.deleteAccountModal}>
          {current === 1 ? (
            <>
              <div className={styles.deleteAccountModalTitle}>
                <DelWarnIc />
                <div>Your Storage</div>
              </div>
              <Flex vertical gap={64}>
                <div>
                  You will lose all your Saved Messages as well as all messages, media
                  and files from your chats.
                </div>
                <Flex gap={16} justify="center">
                  <Button onClick={() => setCurrent(2)}>Continue</Button>
                  <Button type="primary" onClick={() => setOpen(false)}>
                    Come Back Later
                  </Button>
                </Flex>
              </Flex>
            </>
          ) : (
            <>
              <div className={styles.deleteAccountModalTitle}>
                <DelTitleIc />
                <div>Your Message History</div>
              </div>
              <Flex vertical gap={64}>
                <Flex vertical gap={12}>
                  <div>
                    Your chat partners will keep their message history with you,
                    including the messages you shared in Secret Chats.
                  </div>
                  <div>
                    You can remove any messages for both sides at any time, but this
                    will not be possible if you delete your account.
                  </div>
                </Flex>
                <Flex gap={16} justify="center">
                  <Button onClick={() => deleteAccount()}>Continue</Button>
                  <Button type="primary" onClick={() => setOpen(false)}>
                    Come Back Later
                  </Button>
                </Flex>
              </Flex>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};
export default Security;
